import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "./commonLanguageHeader";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface RawDataLogParams {
  imei: string;
  date: string;
  brandName?: string;
  page?: number;
  size?: number;
  fromTime?: string;
  toTime?: string;
  sort?: "ASC" | "DESC";
  sortBy?: string;
}

export interface QueclinkRawDataLogRecord {
  raw?: unknown;
  operation?: string | number;
  id?: string | number;
  timestamp?: number;
  msg_type?: string | number;
  raw_data_log?: unknown;
  decoded?: Record<string, unknown>;
  imei?: string;
  sys_time?: number;
  [key: string]: unknown;
}

export interface TeltonikaRawDataLogRecord {
  id?: string | number;
  createdAt?: number;
  imei?: string;
  eventId?: string | number;
  gps?: unknown;
  io?: unknown;
  priority?: string | number;
  dateTime?: number;
  [key: string]: unknown;
}

export type RawDataLogRecord = QueclinkRawDataLogRecord &
  TeltonikaRawDataLogRecord;

export interface RawDataLogResponse {
  columns?: string[];
  rawData?: RawDataLogRecord[];
  content?: RawDataLogRecord[];
  items?: RawDataLogRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
  numberOfElements?: number;
  [key: string]: unknown;
}

export interface RawDataDeviceLookupItem {
  id?: string | number;
  imei?: string;
  serial?: string;
  name?: string;
  make?: { id?: string | number; name?: string };
  model?: { make?: { id?: string | number; name?: string } };
  [key: string]: unknown;
}

export interface RawDataDeviceLookupParams {
  query: string;
  distributorId?: string | number;
  makeId?: string | number;
}

export const getRawDataLogs = (
  params: RawDataLogParams,
  language?: string,
) =>
  ApiService.get<{ response: RawDataLogResponse }>(
    ServicesUrlEndpoints.RAW_DATA_LOG.LIST,
    {
      params: {
        imei: params.imei,
        date: params.date,
        brandName: params.brandName ?? "",
        page: params.page ?? 0,
        size: params.size ?? 10,
        ...(params.fromTime ? { fromTime: params.fromTime } : {}),
        ...(params.toTime ? { toTime: params.toTime } : {}),
        ...(params.sort ? { sort: params.sort } : {}),
        ...(params.sortBy ? { sortBy: params.sortBy } : {}),
      },
      ...getLanguageHeaders(language),
    },
  );

export const getRawDataDeviceLookup = (
  params: RawDataDeviceLookupParams,
  language?: string,
) =>
  ApiService.get<{ response: RawDataDeviceLookupItem[] }>(
    ServicesUrlEndpoints.RAW_DATA_LOG.DEVICE_LOOKUP,
    {
      params: {
        query: params.query,
        ...(params.distributorId
          ? { distributorId: params.distributorId }
          : {}),
        ...(params.makeId ? { makeId: params.makeId } : {}),
      },
      ...getLanguageHeaders(language),
    },
  );
